module.exports = __webpack_public_path__ + "static/media/sf_2500_gray.894dadafe242bc162ee53b3d57becc46.png";